module.exports = __webpack_public_path__ + "img/tca.d40761f2.svg";